import { useState } from "react"


import { useAuth } from "../../contexts/AuthContext"
import { useFetchTreinamentos } from "../../services/clientes/useClientes";
import { NotFound } from "../../components/NotFound";
import { LoadingOverlay } from "../../components/Loading";
import { Treinamentos } from "./Treinamentos";
import { TreinamentosFilters } from "../../types/cliente/treinamentos/types";


export const TreinamentosContainer = () => {
    const { oidCliente } = useAuth()

    const [filters, setFilters] = useState<TreinamentosFilters>({
        pagina: 1,
        tamanhoPagina: 10,
    })

    const { data, error, isFetching, isError, refetch } = useFetchTreinamentos(
        oidCliente ?? 0,
        filters,
        {
            enabled: !!oidCliente,
            staleTime: Infinity,
        }
    );

    const handlePageChange = (page: number) => {
        setFilters((prev) => ({
            ...prev,
            pagina: page,
        }));
    };

    const handleItemsPerPageChange = (itemsPerPage: number) => {
        setFilters((prev) => ({
            ...prev,
            tamanhoPagina: itemsPerPage,
            pagina: 1,
        }));
    };

    const handleFilter = (newFilters: TreinamentosFilters) => {
        setFilters({
            pagina: 1,
            tamanhoPagina: filters.tamanhoPagina,
            ...newFilters,
        });
    };

    return (
        <>
            {isError && (
                <NotFound
                    error={error}
                    defaultMessage='Erro ao carregar a lista de treinamentos recebidos.'
                    retry={refetch}
                />
            )}
            {isFetching && <LoadingOverlay />}
            {data && <Treinamentos data={data}
                filters={filters}
                onItemsPerPageChange={handleItemsPerPageChange}
                onPageChange={handlePageChange}
                onFilter={handleFilter}
            />}
        </>
    )
}